import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  IAddPaymentPayload,
  ISendReceipt,
  ISendReceiptPreview,
} from '../../../payments-data/payments-data.data';
import { Document } from '../../../document-data/document.model';
import { Billing } from '../../../document-data/sub-models/billing.model';
import { PaymentTransaction } from '../../../document-data/sub-models/payment-transaction.model';
import { IRendererOptions } from '../../../renderer/renderer.interface';
import { PaymentsSettings } from '../../../settings-data/sub-models/company-settings/payments.model';

@Injectable()
export class SendReceiptDialogBuilder {
  constructor(private _translateService: TranslateService) {}

  buildSendReceipt(
    document: Document,
    transaction: PaymentTransaction,
    renderingOptions: IRendererOptions
  ): ISendReceipt {
    return {
      transactionId: transaction.transactionId,
      documentId: document.id,
      documentType: document.documentType,
      documentBilling: document.billing,
      renderingOptions,
    };
  }

  buildSendReceiptPreview(
    dialogType: string,
    transaction: PaymentTransaction,
    renderingOptions: IRendererOptions,
    document: Document
  ): ISendReceiptPreview {
    return {
      dialogType,
      transaction: transaction
        .transactionItemPayload()
        .toJS() as IAddPaymentPayload,
      renderingOptions,
      document,
    };
  }

  buildRenderingOptions(
    paymentsSettings: PaymentsSettings,
    document: Document,
    bankTransferPermission: boolean,
    cardPaymentsPermission: boolean,
    paypalPermission: boolean
  ): IRendererOptions {
    return {
      disable_pay_now_link: false,
      card_payments_globally_enabled:
        cardPaymentsPermission && paymentsSettings.cardPaymentsEnabled(),
      paypal_ec_globally_enabled:
        paypalPermission && paymentsSettings.paypalEcEnabled,
      bank_transfer_globally_enabled:
        bankTransferPermission && paymentsSettings.bankTransferEnabled(),
    };
  }

  buildDescription(documentBilling: Billing): any {
    const recipient =
      documentBilling.name ||
      documentBilling.email ||
      this._translateService.instant('LABEL.NO_CLIENT');
    const email = documentBilling.name ? documentBilling.email : null;

    return email
      ? this._translateService.instant('DIALOG.SEND_RECEIPT.LONG_DESCRIPTION', {
          recipient,
          email,
        })
      : this._translateService.instant(
          'DIALOG.SEND_RECEIPT.SHORT_DESCRIPTION',
          { recipient }
        );
  }
}
